import moment from "moment";
import { useProspectStatusHistory } from "../../../../../../../hooks/fetchers/useProspectStatusHistory/useProspectStatusHistory";
import Loading from "../../../../../../commons/Loading/Loading";
import Modal from "../../../../../../commons/Modal/Modal";
import { StatusHistoryModalProps } from "./StatusHistoryModal.types";

export default ({ prospect, ...props }: StatusHistoryModalProps) => {

  if (!prospect) {
    return null
  }

  const { data: prospectStatusHistory, isLoading } = useProspectStatusHistory(prospect.id)

  return (
    <Modal {...props} closeOnClickOutside style={{ overflowY: 'auto' }}>
      {
        isLoading
          ?
          <Loading />
          :
          <table className="dashboard__table" style={{ flex: 0 }}>
            <thead>
              <th>Statut</th>
              <th>Commentaire</th>
              <th>Date</th>
            </thead>
            <tbody>
              {prospectStatusHistory?.map(({ status, comment, created_at }, index) => (
                <tr key={index}>
                  <td>{status}</td>
                  <td>{comment}</td>
                  <td>{moment(created_at).format('DD/MM/YYYY à HH:mm')}</td>
                </tr>
              ))}
            </tbody>
          </table>
      }
    </Modal>
  )
}